import Cookie from 'js-cookie'

const getPath = function(value) {
  return value[value.length -1] === '/' ? value.substring(0, value.length -1) : value
}

export const setValue = function(key, value, options = {}) {
  if (!options['path']) {
    options['path'] = getPath(process.env.BASE_URL)
  }
  Cookie.set(key, value, options)
}
export const getValue = function(key, options = {}) {
  if (!options['path']) {
    options['path'] = getPath(process.env.BASE_URL)
  }
  return Cookie.get(key, options)
}
export const getJSONValue = function(key, options = {}) {
  if (!options['path']) {
    options['path'] = getPath(process.env.BASE_URL)
  }
  return Cookie.getJSON(key, options)
}
export const removeValue = function(key, options = {}) {
  if (!options['path']) {
    options['path'] = getPath(process.env.BASE_URL)
  }
  Cookie.remove(key, options)
}
export const hasValue = function(key, options = {}) {
  if (!options['path']) {
    options['path'] = getPath(process.env.BASE_URL)
  }
  return !!Cookie.get(key, options)
}
